<template>
  <v-snackbar
    v-model="notification"
    :color="type"
    bottom
    center
    class="text-capitalize"
    :id="`upload_${type}_notification`"
  >
    {{ message }}
  </v-snackbar>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'message',
  data: () => ({
    notification: undefined
  }),
  computed: {
    ...mapGetters('message', ['notifications', 'message', 'type'])
  },
  methods: {
    ...mapActions('message', ['setNotification'])
  },
  watch: {
    notifications (val) {
      this.notification = val
      if (val) {
        setTimeout(() => {
          this.setNotification({
            type: 'warning',
            active: false,
            message: undefined
          })
        }, 8000)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/message/message-v2.vue